import { documentHasElements } from "modules/dom";

documentHasElements(".js-hero-drag-block", (heroDragBlocks) => {
    heroDragBlocks.forEach((heroDragBlock) => {

        const button = heroDragBlock.querySelector<HTMLElement>(".drag-button");
        const leftArea = heroDragBlock.querySelector<HTMLElement>(".area-left");
        const rightArea = heroDragBlock.querySelector<HTMLElement>(".area-right");
              
        button?.addEventListener('mousemove', function (event) {
            //Check if button is dragged
            if (event.buttons > 0) {
                button?.addEventListener('mousemove', touchmove);
            } else {
                button?.removeEventListener('mousemove', touchmove);
            }
        });

        button?.addEventListener('touchstart', function () {
            button?.addEventListener('touchmove', touchmove);            
        });

        let lastX: number | undefined;
        let lastY: number | undefined;

        function touchmove(e: TouchEvent | MouseEvent) {
            let currentX: number;
            let currentY: number;

            if ('touches' in e && e.touches.length > 0) {
                currentX = e.touches[0].clientX;
                currentY = e.touches[0].clientY;
            } else {
                currentX = (e as MouseEvent).clientX;
                currentY = (e as MouseEvent).clientY;
            }

            if (window.innerWidth < 1048) {
                if (lastY !== undefined) {
                    if (currentY > lastY) {
                        // Dragged down
                        leftArea?.classList.remove("dragged");
                        rightArea?.classList.remove("dragged");
                    } else if (currentY < lastY) {
                        // Dragged up
                        leftArea?.classList.add("dragged");
                        rightArea?.classList.add("dragged");
                    }
                }
            } else {
                if (lastX !== undefined) {
                    if (currentX > lastX) {
                        // Dragged right
                        leftArea?.classList.remove("dragged");
                        rightArea?.classList.remove("dragged");
                    } else if (currentX < lastX) {
                        // Dragged left
                        leftArea?.classList.add("dragged");
                        rightArea?.classList.add("dragged");
                    }
                }
            }

            lastX = currentX;
            lastY = currentY;
        }

    });
});